import doLineSegmentsIntersect from './line_segments_intersect'
import mapConverters from './map_converters'
import mapEvents from './map_events'
import mapModals from './map_modals'

export const defaultShapeOptions = {
  fillOpacity: 0.4,
  strokeWeight: 1
};

// Helper function to check if shape management is enabled
function isShapeManagementEnabled() {
  return $('[data-mweb-shape-management="yes"]').length > 0;
}

export default class DrawingManager {

  constructor(googleMap, markerManager) {
    this.drawings = [];
    this.googleMap = googleMap;
    this.markerManager = markerManager;
    // We draw our own circles now.  This is our holder for the circle in progress.
    this.circleInProgress = null;
    
    this._drawingInProgress = false;
    this._drawingsVisible = true;
    this.selectedShape = null;
    this.editingShape = null;
    var self = this;

    // When the user clicks on the map, a dropdown, a button or a checkbox, remove any shape context menu that might be visible.
    this.googleMap.addListener('click',this.resetShapesMenu.bind(this));
    this.googleMap.addListener('drag',this.resetShapesMenu.bind(this));
    this.googleMap.addListener('zoom_changed',this.resetShapesMenu.bind(this));
    $(document).on('shown.bs.dropdown', this.resetShapesMenu.bind(this));
    window.addEventListener('cleanup-rightleft-content', this.resetShapesMenu.bind(this))
    $('button:not(#deleteDrawingBtn)').on('click',this.resetShapesMenu.bind(this));
    $('input:checkbox').on('click',this.resetShapesMenu.bind(this));
    $(window).on('resize',this.resetShapesMenu.bind(this));

    this._drawnShapeColorChangedListener = null;
    this._drawnShapeNameChangedListener = null;
    this._drawnShapeStartEditListener = null;

  }

  resetShapesMenu() {
    if (window.activeMenuController && window.activeMenuController.shieldsUp) {
      // Klingon: Damn you Kirk!
      return
    }
    if (window.activeOverlayController && window.activeOverlayController.shieldsUp) {
      // Darth Vadar: You have failed me for the LAST time!
      return
    }

    $('#drawnShapeManagementMenu').css({ display: 'none'});
    $('#colorChoices').addClass('hidden');
    this.selectedShape = null;
    this.resetAllShapesOpacity();
  }

  resetAllShapesOpacity() {
    this.drawings.forEach( function(shape) {
      shape.set('fillOpacity',mapConverters.defaultShapeProperties.fillOpacity);
    })
  }
  
  resetAllShapesClickability(clickable) {
    this.drawings.forEach( function(shape) {
      shape.setOptions({clickable: isShapeManagementEnabled() ? false : clickable});
    });
  }
  
  hasDrawings() {
    return this.drawings.length > 0;
  }

  drawingsVisible() {
    return this._drawingsVisible;
  }

  displayShapeContextMenu(x,y) {
    // Make sure we reset the color toggle in case we clicked on a shape while
    // this menu is open.
    $('#colorChoices').addClass('hidden')
    $('.drawnShapeColorToggle').removeClass('flexicon-270').addClass('flexicon-90')

    var windowWidth = $(window).width();
    var windowHeight = $(window).height();
    var menuWidth = $('#drawnShapeManagementMenu').width();
    var menuHeight = $('#drawnShapeManagementMenu').height();

    if (x + menuWidth > windowWidth) {
      x -= menuWidth;
    }
    x = Math.max(16, Math.min(x, windowWidth - menuWidth - 16));

    if (y + menuHeight > windowHeight) {
      y -= menuHeight;

      // If the menu is displaying upwards from the mouse
      // align the color selector with the bottom of the menu so it cant
      $('#colorChoices').css('top', 'auto');
      $('#colorChoices').css('bottom', 0 + 'px')
    } else {
      // Check to see if the color choices will go past the bottom of the
      // window. (Sorry for the hard coded value.  How to know the height
      // when it is hidden?)
      if (y + 290 > windowHeight) {
        // color choices would go off the screen.  Align it with the bottom of
        // the menu
        $('#colorChoices').css('top', 'auto');
        $('#colorChoices').css('bottom', 0 + 'px')
      } else {
        // Color choices should be aligned with the top of the menu.
        $('#colorChoices').css('top', 0 + 'px');
        $('#colorChoices').css('bottom', 'auto')
      }
    }

    if(this._drawnShapeColorChangedListener === null) {
      this._drawnShapeColorChangedListener = window.addEventListener('drawnShapeColorChanged', this.drawnShapeColorChangedHandler.bind(this));
    }

    if(this._drawnShapeNameChangedListener === null) {
      this._drawnShapeNameChangedListener = window.addEventListener('drawnShapeNameChanged', this.drawnShapeNameChangedHandler.bind(this));
    }

    if(this._drawnShapeStartEditListener === null) {
      this._drawnShapeStartEditListener = window.addEventListener('drawnShapeStartEdit', this.drawnShapeStartEditHandler.bind(this))
    }

    $('#drawnShapeManagementMenu').css({ left: x + 'px', top: y + 'px', display: 'block', 'z-index': 500});

  }

  add(shape, annotation) {
    shape.visible = this._drawingsVisible;
    if (annotation) {
      var shapeProperties = mapConverters.defaultShapeProperties

      var color = annotation?.Attributes?.Color ?? shapeProperties.fillColor;
      if (!color.startsWith('#')) {
        color = '#' + color;
      }

      shape.set('fillColor', color);
      shape.set('strokeColor', color);
      shape.set('strokeWeight', shapeProperties.strokeWeight);
      shape.set('strokeOpacity', shapeProperties.strokeOpacity);
      shape.set('fillOpacity', shapeProperties.fillOpacity);
      shape.set('shapeName', annotation.Attributes.Label);
    }

    // Ensure drawn shapes have a proper z-index to appear above unfiltered overlay shapes
    if (!shape.get('zIndex')) {
      shape.set('zIndex', 10);
    }

    this.drawings.push(shape);
    shape.setMap(this.googleMap);
    shape.addListener('click', this.handleShapeClick.bind(this, shape));
    
    if (!isShapeManagementEnabled()) {
      shape.addListener('mouseover', function(event) {
        if (!self._drawingMode) {
          shape.set('fillOpacity', 0.7);
        }
      });
      shape.addListener('mouseout', function(event) {
        if (shape !== self.selectedShape){
          shape.set('fillOpacity', 0.5);
        }
        // Else the shape is the one associated with the context menu.
        // Keep that hightlighted until the context menu is closed.
      });
    }
  }

  handleShapeClick(shape, event) {
    if ($('.shape-edit-in-progress').length > 0) {
      // We are editing a shape.  Dont show the menu.
      return;
    }

    if (this.selectedShape != null && this.selectedShape !== shape) {
      // If another shape was selected and displaying the context menu
      // set the other shape's opacity back to normal.
      this.selectedShape.set('fillOpacity', 0.5);
    }
    this.selectedShape = shape;
    shape.set('fillOpacity', 0.7);
    // Populate the context menu
    $('#drawnShapeColor .selected-color-inner').css('background-color', shape.get('fillColor')).attr('data-color', shape.get('fillColor'))
    $('#drawnShapeName').val(shape.get('shapeName')).attr('data-original-name', shape.get('shapeName'));
    $('#drawnShapeCondition').val(shape.condition)

    // RM-1819 FLIP SWITCH CHECK
    if (isShapeManagementEnabled()) {
      if (shape instanceof google.maps.Polygon && Flexmls.currentUser.role === 'private') {
        $('#shapeMenuAddToOverlay').parent().removeClass('hidden')
      } else {
        $('#shapeMenuAddToOverlay').parent().addClass('hidden')
      }
    }

    this.displayShapeContextMenu(event.domEvent.pageX, event.domEvent.pageY);
  }


  deleteDrawing(shape) {
    shape.visible = false;
    var index = this.drawings.indexOf(shape);
    if (index >= 0) {
      shape.visible = false;
      shape.setMap(null);
      this.drawings.splice(index, 1);
    }
  }

  toggleVisibility(visible) {
    var self = this;    
    var oldDrawings = this.drawings;
    this.deleteAll();

    oldDrawings.forEach((drawing) => {
      drawing.visible = visible;
      self.drawings.push(drawing);
      drawing.setMap(self.googleMap);
    });
    this._drawingsVisible = visible;
  }

  getBoundsForMultipleShapes() {
    var bounds = null;
    if (this.drawings.length === 0) {
      return null;
    }
    const combinedBounds = new google.maps.LatLngBounds();

    this.drawings.forEach((drawing) => {
      if (drawing instanceof google.maps.Polygon) {
        // Extend bounds with every polygon vertex
        drawing.getPath().forEach(latLng => combinedBounds.extend(latLng));
      } else if (drawing instanceof google.maps.Rectangle) {
        // Clone rectangle bounds to avoid reference issues
        const rectBounds = drawing.getBounds();
        const sw = rectBounds.getSouthWest();
        const ne = rectBounds.getNorthEast();
        combinedBounds.union(new google.maps.LatLngBounds(sw, ne));
      } else {
        // For circles/polylines/markers, use default bounds
        combinedBounds.union(drawing.getBounds());
      }
    });
    return combinedBounds;
  }

  deleteAll() {
    if(this.drawings.length > 0) {
      this.drawings.forEach(function(drawing){
        drawing.setMap(null);
      });
      this.drawings = [];
    }
  }


  drawingInProgress() {
    return this._drawingInProgress;
  }

  startDrawing(shape) {
    switch(shape) {
      case 'polygon':
        this.startDrawingPolygon();
        break;
      case 'circle':
        this.startDrawingCircle();
        break;
      case 'rectangle':
        this.startDrawingRectangle();
        break;
    }
  }

  startDrawingPolygon() {
    this._drawingInProgress = true;
    this._drawingMode = google.maps.drawing.OverlayType.POLYGON;
    let polygonProperties = mapConverters.defaultShapeProperties;
    let polygonOptions = $.extend({}, defaultShapeOptions, polygonProperties);
    polygonOptions.clickable = isShapeManagementEnabled() ? false : true;
    // Use these settings only while drawing
    polygonOptions.strokeWeight = mapConverters.defaultDrawingProperties.strokeWeight;
    polygonOptions.strokeOpacity = mapConverters.defaultDrawingProperties.strokeOpacity;

    // We are only making the polygon editable so that the handle will appear
    // after the first click. Otherwise, the user doesn't get any feedback
    // that their click has added a point. Editing is turned off in the
    // polygoncomplete handler.
    polygonOptions.editable = true;

    if(typeof this.googleDrawingManager === 'undefined'){
      this.googleDrawingManager = new google.maps.drawing.DrawingManager({
        drawingMode: this._drawingMode,
        drawingControl: false,
        polygonOptions: polygonOptions
      });
    }

    if(typeof this._shapeCompleteListener === 'undefined') {
      this._shapeCompleteListener = google.maps.event.addListener(
        this.googleDrawingManager, 
        'polygoncomplete', 
        this._polygonCompleteHandler.bind(this)
      );
    }

    this.googleDrawingManager.setDrawingMode(this._drawingMode);
    this.googleDrawingManager.setMap(this.googleMap);
  }

  startDrawingRectangle() {
    this._drawingInProgress = true;
    this._drawingMode = google.maps.drawing.OverlayType.RECTANGLE;
    let rectangleProperties = mapConverters.defaultShapeProperties;
    let rectangleOptions = $.extend({}, defaultShapeOptions, rectangleProperties);
    rectangleOptions.clickable = isShapeManagementEnabled() ? false : true;
    // Use these settings only while drawing
    rectangleOptions.strokeWeight = mapConverters.defaultDrawingProperties.strokeWeight;
    rectangleOptions.strokeOpacity = mapConverters.defaultDrawingProperties.strokeOpacity;

    // We are only making the rectangle editable so that the handle will appear
    // after the first click. Otherwise, the user doesn't get any feedback
    // that their click has added a point. Editing is turned off in the
    // rectanglecomplete handler.
    rectangleOptions.editable = true;

    if(typeof this.googleDrawingManager === 'undefined'){
      this.googleDrawingManager = new google.maps.drawing.DrawingManager({
        drawingMode: this._drawingMode,
        drawingControl: false,
        rectangleOptions: rectangleOptions
      });
    }

    if(typeof this._shapeCompleteListener === 'undefined') {
      this._shapeCompleteListener = google.maps.event.addListener(
        this.googleDrawingManager, 
        'rectanglecomplete', 
        this._rectangleCompleteHandler.bind(this)
      );
    }

    this.googleDrawingManager.setDrawingMode(this._drawingMode);
    this.googleDrawingManager.setMap(this.googleMap);
  }

  startDrawingCircle() {
    this._drawingInProgress = true;
    this._drawingMode = google.maps.drawing.OverlayType.CIRCLE;

    // Freeze the map
    this.googleMap.setOptions({draggable: false});
    // Make sure we can click on existing shapes without interfacing with them.
    this.resetAllShapesClickability(false);
    // Start listening for the user to click to define the center of the circle.
    this.circleMouseDownListener = this.googleMap.addListener('mousedown', this.startDrawingACircleWithRadius.bind(this));
    $("#mapContainer").css("cursor", "drawing-in-progress");
  }


  cancelDrawing() {
    // If we are drawing a circle, there is some special cleanup
    this.cleanupCircleDrawingMode();

    google.maps.event.removeListener(this._shapeCompleteListener);
    delete this._shapeCompleteListener;

    this._drawingInProgress = false;
    if (this.googleDrawingManager) {
      // erase an incomplete drawing
      this.googleDrawingManager.setMap(null);
      // exit drawing mode
      this.googleDrawingManager.setDrawingMode(null);
      this.googleDrawingManger = null;
      delete this.googleDrawingManager;
    }
    this._drawingMode = null;
    window.dispatchEvent(mapEvents.drawingComplete());
  }

  _polygonCompleteHandler(polygon) {
    var pointsArray = polygon.getPath();

    if(this._validatePath(pointsArray)){
      this._drawingInProgress = false;

      polygon.setEditable(false);
      polygon.set('shapeName', 'Polygon');
      var shapeProperties = mapConverters.defaultShapeProperties;
      //change drawing mode only options back to regular options
      polygon.set('strokeWeight',shapeProperties.strokeWeight);
      polygon.set('strokeOpacity', shapeProperties.strokeOpacity);
      polygon.set('zIndex', 10);

      this.add(polygon);

      this.googleDrawingManager.setDrawingMode(null);
      this._drawingMode = null;

      window.dispatchEvent(mapEvents.drawingComplete(polygon));

      google.maps.event.removeListener(this._shapeCompleteListener);
      delete this._shapeCompleteListener;
      this.googleDrawingManager = null;
      delete this.googleDrawingManager;

    } else {
      polygon.setMap(null);
      window.dispatchEvent(mapEvents.drawingError());
    }
  }

  _rectangleCompleteHandler(rectangle) {
    var minDistance = 25.0;
    this._drawingInProgress = false;

    rectangle.setEditable(false);

    // Make sure that a minimal sized rectangle has been drawn.  And enlarge
    // the rectangle if it is too small.
    var distance = google.maps.geometry.spherical.computeDistanceBetween(rectangle.getBounds().getNorthEast(), rectangle.getBounds().getSouthWest());
    while (distance < minDistance) {
      // 0.000001 is the smallest meaningful lat/lng unit (for our purposes).  We are moving the 2 corners to try to get a
      // rectangle that is also meaningful and does not break the system (25 meters corner to corner for now).
      var southWest = new google.maps.LatLng(rectangle.getBounds().getSouthWest().lat() - 0.000001, rectangle.getBounds().getSouthWest().lng() - 0.000001);
      var northEast = new google.maps.LatLng(rectangle.getBounds().getNorthEast().lat() + 0.000001, rectangle.getBounds().getNorthEast().lng() + 0.000001);
      rectangle.setBounds(new google.maps.LatLngBounds(southWest, northEast));
      distance = google.maps.geometry.spherical.computeDistanceBetween(rectangle.getBounds().getNorthEast(), rectangle.getBounds().getSouthWest());
    }

    rectangle.set('shapeName', "Rectangle");
    //change drawing mode only options back to regular options
    var shapeProperties = mapConverters.defaultShapeProperties;
    rectangle.set('strokeWeight',shapeProperties.strokeWeight);
    rectangle.set('strokeOpacity', shapeProperties.strokeOpacity);
    rectangle.set('zIndex', 10);

    this.add(rectangle);

    this.googleDrawingManager.setDrawingMode(null);
    this._drawingMode = null;

    window.dispatchEvent(mapEvents.drawingComplete(rectangle));

    google.maps.event.removeListener(this._shapeCompleteListener);
    delete this._shapeCompleteListener;
    this.googleDrawingManager = null;
    delete this.googleDrawingManager;
  }

  _circleCompleteHandler(circle) {
      this._drawingInProgress = false;
      circle.setEditable(false);

      circle.set('shapeName', 'Circle');
      //change drawing mode only options back to regular options
      var shapeProperties = mapConverters.defaultShapeProperties;
      circle.set('strokeWeight',shapeProperties.strokeWeight);
      circle.set('strokeOpacity', shapeProperties.strokeOpacity);
      circle.set('zIndex', 10);

      this.add(circle);

      if (this.googleDrawingManager) {
        this.googleDrawingManager.setDrawingMode(null);
      }
      this._drawingMode = null;

      window.dispatchEvent(mapEvents.drawingComplete(circle));

      google.maps.event.removeListener(this._shapeCompleteListener);
  }

  _drawnCircleChangedHandler() {
    // Circles have an added marker that shows the radius of the circle.
    // When the shape is edited, update that marker.
    this.markerManager.editRadiusMarker(this.editingShape)
  }

  _validatePath(googlePointsArray){

    if(googlePointsArray.length < 3){
      return false;
    }

    var pointsArray = mapConverters.googlePointsToXYPoints(googlePointsArray);

    for (var i=0; i < (pointsArray.length - 1); i++) {

      var a = pointsArray[i];
      var b = pointsArray[i+1];

      for (var j=i; j < (pointsArray.length - 2); j++) {
        var c = pointsArray[j+2];
        var d;
        if (j+3 < pointsArray.length){
          d = pointsArray[j+3];
        } else if (i !== 0 ) {
          d = pointsArray[0];
        } else {
          continue;
        }

        if(doLineSegmentsIntersect(a, b, c, d)) {
          return false;
        }

      }
    }

    return true;
  }

  startDrawingACircleWithRadius(event) {
    // Get desired circle properties
    let circleProperties = mapConverters.defaultShapeProperties;
    let circleOptions = $.extend({}, defaultShapeOptions, circleProperties);
    // Always false when drawing a circle
    circleOptions.clickable = false;
    circleOptions.strokeWeight = mapConverters.defaultDrawingProperties.strokeWeight;
    circleOptions.strokeOpacity = mapConverters.defaultDrawingProperties.strokeOpacity;
    circleOptions.center = event.latLng;
    // Start the circle with a very small radius
    circleOptions.radius = 1.0;
    // Note the time.  This will help with accidental click-while-dragging hits.
    // Basically, if the user wants to define the circle by clicking then moving the mouse then clicking
    // again (instead of mousedown, drag, mouseup) we need to make sure any unintentional drag during the
    // click did not happen.
    this.circleCreationStartTime = new Date();

    // Create the circle, add it to the map and make it look like a circle in progress.
    this.circleInProgress = new google.maps.Circle(circleOptions);
    this.circleInProgress.setMap(this.googleMap);

    // Add the new radius marker at the right-most edge of the circle.
    this.markerManager.addRadiusMarker(this.circleInProgress);

    // Listen for other mouse events
    this.circleMouseMoveListener = this.googleMap.addListener('mousemove', this.updateNewCircleRadius.bind(this));
    this.circleMouseUpListener = this.googleMap.addListener('mouseup', this.stopDrawingNewCircle.bind(this));

    // No need to listen for mouse down anymore.
    google.maps.event.removeListener(this.circleMouseDownListener);
  }

  updateNewCircleRadius(event) {
    // Process mouse movements while circle is being drawn
    if (this.circleInProgress) {
      // If drawing a circle, calculate the new radius based on where the mouse is...
      var radius = google.maps.geometry.spherical.computeDistanceBetween(this.circleInProgress.getCenter(), event.latLng);
      this.circleInProgress.setRadius(radius);
      // ...and update the radius marker.
      this.markerManager.editRadiusMarker(this.circleInProgress);
    }
  }

  stopDrawingNewCircle(event) {
    // Mouse up event
    // How lon has the mouse been down?
    var dragTime = ((new Date()).getTime() - this.circleCreationStartTime.getTime());
    // How far from the center point is the mouse now?
    var radius = google.maps.geometry.spherical.computeDistanceBetween(this.circleInProgress.getCenter(), event.latLng);

    // If user clicked (instead of mouse down to drag) keep drawing.
    if (radius <= 1.0) return;
    // Did the user mean to click instead of drag?  (These values may need to be tweeked.  But they work well for me.)
    if (dragTime < 1000 && radius < 30) return;

    // Looks like we really are done drawing the circle.  Set the radius.
    this.circleInProgress.setRadius(radius);

    var circle = this.circleInProgress;
    circle.setOptions({clickable: isShapeManagementEnabled() ? false : true});
    this._circleCompleteHandler(circle);
    this.circleInProgress = null;
    this.cleanupCircleDrawingMode();
  }

  startDrawingCircle() {
    this._drawingInProgress = true;
    this._drawingMode = google.maps.drawing.OverlayType.CIRCLE;

    this.googleMap.setOptions({draggable: false});
    this.resetAllShapesClickability(false);
    this.circleMouseDownListener = this.googleMap.addListener('mousedown', this.startDrawingACircleWithRadius.bind(this));
  }

  cleanupCircleDrawingMode() {

    if (this.circleInProgress != null) {
      this.markerManager.removeShapeMarker(this.circleInProgress);
      this.circleInProgress.setMap(null);
    }
    google.maps.event.removeListener(this.circleMouseDownListener);
    google.maps.event.removeListener(this.circleMouseMoveListener);
    google.maps.event.removeListener(this.circleMouseUpListener);

    this.googleMap.setOptions({draggable: true});

    this.circleInProgress = null;
    this.resetAllShapesClickability(true);
  }

  highlightShape(shapeDef) {
    let self = this;
    this.drawings.forEach(function (shape){
      if (self.shapeDefsEqual(shape.condition,shapeDef)) {
        shape.set('fillOpacity',0.9);
        return;
      }
    });
  }

  unhighlightShape(shapeDef) {
    let self = this;
    this.drawings.forEach(function (shape){
      if (self.shapeDefsEqual(shape.condition,shapeDef)) {
        shape.set('fillOpacity',0.5);
        return;
      }
    });
  }

  shapeDefsEqual(shapeDef1, shapeDef2) {
    return (shapeDef1.replaceAll(', ', ',') === shapeDef2.replaceAll(', ', ','))
  }

  drawnShapeColorChangedHandler(event) {
    if (this.selectedShape !== null) {
      this.selectedShape.set('fillColor',event.detail.newColor)
      this.selectedShape.set('strokeColor',event.detail.newColor)
    }
  }

  drawnShapeNameChangedHandler(event) {
    if (this.selectedShape !== null) {
      this.selectedShape.set('shapeName',event.detail.newName)
    }
  }

  drawnShapeStartEditHandler(event) {
    if (this.selectedShape === null) {
      return;
    }
    this.markerManager.deleteMarkers();
    this.editingShape = this.selectedShape;
    this.selectedShape = null;
    this.editingShape.setEditable(true)

    const shapeEditControlDiv = document.createElement('div')
    shapeEditControlDiv.id = 'drawnShapeEditControlBtns'
    shapeEditControlDiv.dataset.existingShapeDef = event.detail.targetShape;
    shapeEditControlDiv.style.margin = '8px'

    const cancelControlUI = this.createCancelEditBtn(this.editingShape)
    shapeEditControlDiv.appendChild(cancelControlUI);
    cancelControlUI.addEventListener('click', this.cancelShapeEdit.bind(this))

    const doneControlUI = this.createDoneEditBtn();
    shapeEditControlDiv.appendChild(doneControlUI);
    doneControlUI.addEventListener('click', this.drawnShapeEditComplete.bind(this))


    // Add the control to the map (top right in this example)
    this.googleMap.controls[google.maps.ControlPosition.TOP_CENTER].push(shapeEditControlDiv);

    // Dont allow someone to create a new shape while we are editing this one.
    $('#drawOnMapBtn').prop('disabled', true);

    if (this.editingShape instanceof google.maps.Circle) {
      if(typeof this._drawnCircleRadiusChangedListener === 'undefined') {
        this._drawnCircleRadiusChangedListener = google.maps.event.addListener(
          this.editingShape,
          'radius_changed',
          this._drawnCircleChangedHandler.bind(this)
        );
      }
      if(typeof this._drawnCircleCenterChangedListener === 'undefined') {
        this._drawnCircleCenterChangedListener = google.maps.event.addListener(
          this.editingShape,
          'center_changed',
          this._drawnCircleChangedHandler.bind(this)
        );
      }
    }

    this._drawingInProgress = true;
  }

  drawnShapeEditComplete(event) {
    this._drawingInProgress = false;
    $('#drawOnMapBtn').prop('disabled', false);

    // Remove the click listener from the header.
    $('#drawingModeHeader').off('click', this.drawnShapeEditComplete.bind(this));

    // Get info from the edit buttons div and then clear it
    let originalShapeDef = $('#drawnShapeEditControlBtns').data('existingShapeDef');
    this.googleMap.controls[google.maps.ControlPosition.TOP_CENTER].clear();

    // If we are editing a shape (which we should be if we got here)...
    if (this.editingShape !== null) {
      // Turn of edit mode
      this.editingShape.setEditable(false)

      // If we were editing a circle turn off the special handlers for that.
      if (this.editingShape instanceof google.maps.Circle) {
        delete this._drawnCircleRadiusChangedListener;
        delete this._drawnCircleCenterChangedListener;
      }

      // Tell flexmls_map to update the filters and annotations.  That is more
      // equipped to do that than the drawing manager.
      let myData = {
        detail:
        {
          oldShapeDef: originalShapeDef,
          newShape: this.editingShape
        }
      };
      window.dispatchEvent(new CustomEvent('map:drawnShapeEditComplete', myData));

      // We are no longer editing a shape.  And we dont need any more info from it.
      this.editingShape = null;
    }
  }

  cancelShapeEdit(event) {
    let originalShapeDef = $('#drawnShapeEditControlBtns').data('existingShapeDef');

    this._drawingInProgress = false;
    $('#drawOnMapBtn').prop('disabled', false);

    // If we are editing a shape (which we should be if we got here)...
    if (this.editingShape !== null) {
      // Turn off edit mode
      this.editingShape.setEditable(false)

      const shapeType = event.target.dataset.shapeType;
      const originalGeometry = JSON.parse(event.target.dataset.originalGeometry);

      switch (shapeType) {
        case 'polygon':
          // setPaths can take Array<Array<LatLngLiteral>>
          this.editingShape.setPaths(originalGeometry);
          break;
        case 'polyline':
          // setPath can take Array<LatLngLiteral>
          this.editingShape.setPath(originalGeometry);
          break;
        case 'circle':
          this.editingShape.setCenter(originalGeometry.center);
          this.editingShape.setRadius(originalGeometry.radius);
          break;
        case 'rectangle':
          // LatLngBounds constructor takes LatLngBoundsLiteral or two LatLngLiterals
          this.editingShape.setBounds(originalGeometry); // {north, south, east, west}
          break;
        default:
          console.error("Unknown shape type found on button data.");
          return;
      }
      // Clear the buttons from the top of the map
      this.googleMap.controls[google.maps.ControlPosition.TOP_CENTER].clear();

      // Tell flexmls_map to update the filters and annotations.  That is more
      // equipped to do that than the drawing manager.
      let myData = {
        detail:
        {
          oldShapeDef: originalShapeDef,
          newShape: null
        }
      };
      window.dispatchEvent(new CustomEvent('map:drawnShapeEditComplete', myData));

      // We are no longer editing a shape.  And we dont need any more info from it.
      this.editingShape = null;
    }
  }

  createDoneEditBtn(shape) {
    let doneEditBtn = document.createElement('button');
    doneEditBtn.textContent = 'Done Editing';
    doneEditBtn.className = 'btn btn-primary shape-edit-in-progress';
    doneEditBtn.style.marginLeft = '4px';
    return doneEditBtn;
  }

  createCancelEditBtn(shape) {
    let shapeType = '';
    let originalShapeData = {};

    let cancelBtn = document.createElement('button');
    cancelBtn.textContent = 'Cancel Editing';
    cancelBtn.className = 'btn btn-secondary shape-edit-in-progress';

    if (shape instanceof google.maps.Polygon) {
      shapeType = 'polygon';
      const paths = shape.getPaths().getArray();
      const pathLiterals = [];
      paths.forEach(mvcPath => {
        const singlePath = [];
        mvcPath.getArray().forEach(latLng => {
          singlePath.push({ lat: latLng.lat(), lng: latLng.lng() });
        });
        pathLiterals.push(singlePath);
      });
      originalShapeData = pathLiterals;
    } else if (shape instanceof google.maps.Circle) {
      shapeType = 'circle';
      const center = shape.getCenter();
      originalShapeData = {
        center: { lat: center.lat(), lng: center.lng() },
        radius: shape.getRadius()
      };
    } else if (shape instanceof google.maps.Rectangle) {
      shapeType = 'rectangle';
      const bounds = shape.getBounds();
      const ne = bounds.getNorthEast();
      const sw = bounds.getSouthWest();
      originalShapeData = {
        north: ne.lat(),
        east: ne.lng(),
        south: sw.lat(),
        west: sw.lng()
      };
    }

    // Store data on the button
    cancelBtn.dataset.shapeType = shapeType;
    cancelBtn.dataset.originalGeometry = JSON.stringify(originalShapeData); // Store as JSON string
    return cancelBtn;
  }

  displayOverlayManager(details, addShapeToOverlayModal) {
    const selectedShapeItemHiddenData =  `
      <input type="hidden" name="label_ITEMNUMBER" value="POLYGON_NAME">
      <input type="hidden" name="color_ITEMNUMBER" value="POLYGON_COLOR">
      <input type="hidden" name="coords_ITEMNUMBER" value="POLYGON_POINTS">
    `

    const selectedShapeItemFormGroup = `
      <div class="form-group">
        <label for="selected_ITEMNUMBER" style="display: flex; align-items: center; font-weight: 400 !important">
          <input type="checkbox" id="selected_ITEMNUMBER" value="Y" data-overlay-editor-modal-target="polygonCheckbox" data-action="change->overlay-editor-modal#validate" ISCHECKED>
          <span style="display: inline-block; width: 14px; height: 14px; border-radius: 50%; margin-left: 12px; background-color: POLYGON_COLOR;"></span>
          <span style="margin-left: 4px">POLYGON_NAME</span>
        </label>
      </div>
    `

    let polygonCount = 0;
    let allHiddenFields = '';
    let allFormFields = ''

    for (const shape of this.drawings) {
      if (shape instanceof google.maps.Polygon) {
        polygonCount++;
        // --- Build the pointsString ---
        const path = shape.getPath(); // Get the array of LatLng vertices
        const pointsArray = path.getArray().map(latLng => {
          // For each point, create a "lng,lat" string, multiplying by 1,000,000 and rounding
          const lng = Math.round(latLng.lng() * 1000000);
          const lat = Math.round(latLng.lat() * 1000000);
          return `${lng},${lat}`;
        });
        // close the polygon if it is not already closed.
        if (pointsArray.length > 2 && pointsArray[0] !== pointsArray[pointsArray.length - 1]) {
          pointsArray.push(pointsArray[0]);
        }
        // Join all the "lng,lat" strings together with a semicolon
        const pointsString = pointsArray.join(';');
        let color = shape.get('fillColor').replace('#','');

        let newHiddenString = selectedShapeItemHiddenData.replaceAll('_ITEMNUMBER', polygonCount);
        newHiddenString = newHiddenString.replace('POLYGON_COLOR', color);
        newHiddenString = newHiddenString.replace('POLYGON_NAME', shape.get('shapeName'));
        newHiddenString = newHiddenString.replace('POLYGON_POINTS', pointsString);
        allHiddenFields += newHiddenString

        let newFormGroup = selectedShapeItemFormGroup.replaceAll('_ITEMNUMBER', polygonCount);
        if (shape.get('condition') === details.initialShapeCondition) {
          newFormGroup = newFormGroup.replace('ISCHECKED', 'checked');
        } else {
          newFormGroup = newFormGroup.replace('ISCHECKED', '');
        }
        newFormGroup = newFormGroup.replace('POLYGON_COLOR', '#' + color);
        newFormGroup = newFormGroup.replace('POLYGON_NAME', shape.get('shapeName'));
        allFormFields += newFormGroup;
      }
    }

    setTimeout(() => {
      window.dispatchEvent(new CustomEvent("display-local-modal", {
        detail: {
          modalCssClasses: "modal-dialog c-modal c-modal-gray",
          modalContentCssClasses: "c-modal__content--white",
          modalHeader: `<div class="t-title--large">Add Polygons to My Map Overlay</div>`,
          modalFooterContent: mapModals.overlayModalButtons,
          modalContent: mapModals.addOverlayModal(allHiddenFields, polygonCount, allFormFields),
          modalDataController: "overlay-editor-modal",
          modalDataAction: "map:newOverlayCreated@window->modal#dismissLocal map:overlayUpdated@window->modal#dismissLocal"
        }
      }));
    }, 10)

  }
}
